// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"590":"3e1520a7","724":"f4827169","737":"e163a12b","852":"590f9a67","925":"eca019f0"}[chunkId] + ".css";
};